import React, {FC, ReactNode, useState} from 'react'
import {IActionContext} from "@context/actionContext/types/actionContext";
import {ISnackbarState} from "@ui/snackBars/types";
import {IConfirmState} from "@ui/confirm/types";

export const ActionContext = React.createContext<IActionContext | null>(null)

interface IProps {
    children: ReactNode
}

const ActionContextProvider: FC<IProps> = ({
                                               children,
                                           }) => {


    const [snackBar, setSnackBar] = useState<ISnackbarState>({
        open: false,
        title: '',
        message: '',
        variant: 'success',
    })

    const [confirm, setConfirm] = useState<IConfirmState>({
        open: false,
        title: '',
        message: '',
        callback: null,
        cancelCallback:null,

    })
    const [visibleMobileSidebar, setVisibleMobileSidebar] = useState(false)


    return (
        <ActionContext.Provider value={{
            snackBar, setSnackBar,
            confirm, setConfirm,
            visibleMobileSidebar, setVisibleMobileSidebar,
        }}
        >
            {children}
        </ActionContext.Provider>
    );
};

export default ActionContextProvider;
